import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import {HandleLoginHeader} from "./login";
import Input from "@atoms/input";
import Selection from "@molecules/selection/selection";
import {Container as SelectionContainer} from "@molecules/selection/components/styles";
import {Container as SelectionDropdownContainer} from '@molecules/selection/components/dropdown';
import {Header as SelectionDropdownHeader} from '@molecules/selection/components/dropdwon.header';
import {Container as SelectionDropdownList} from '@molecules/selection/components/lists';
import {citiesSelection} from "@hooks/cities";
import RadiusGenerate from "@helpers/radius.generate";
import ButtonBase from "@atoms/button.base";
import {districtsSelection} from "@hooks/districts";
import {isEmpty} from "@helpers/helpers";

import CircleLoading from "@molecules/lotties/circle_loading";
import Captcha from "./captcha";

const errorsFields = {
    name: {show: false, text: 'فیلد نام الزامی است.'},
    agency_name: {show: false, text: 'فیلد نام دفتر املاک الزامی است.'},
    city_id: {show: false, text: 'شهر الزامی است.'},
    district_id: {show: false, text: 'خیابان الزامی است.'},
};

function SignUpRealtor({level, show, setShow, handleContinue, fields, setFields, handleRegister, handleForceRefreshCaptcha, handleCaptchaChange}) {
    const [cities, setCities] = useState({options: [], selected_items: []});
    const [districts, setDistrict] = useState({options: [], selected_items: []});
    const [districtLoading, setDistrictLoading] = useState(false);
    const [registerRealtor, setRegisterRealtor] = useState({
        name: "",
        agency_name: "",
        city_id: "",
        district_id: "",
        errors: errorsFields,
    });

    useEffect(() => {
        citiesSelection().then((result) => {
            if (result) {
                setCities(result);

                if (result.selected_items && !isEmpty(result.selected_items[0])) {
                    getDistricts(result.selected_items[0])
                }
            }
        })
    }, []);

    useEffect(() => {
        setRegisterRealtor(state => ({
            ...state,
            errors: errorsFields
        }));
    }, [fields]);

    useEffect(() => {
        const handleUserKeyPress = (event) => {
            const {key, keyCode} = event;
            if (show && keyCode === 13) {
                if (level.sign_up_realtor) {
                    handleSingUp();
                }
            }
        };
        window.addEventListener('keydown', handleUserKeyPress);
        return () => {
            window.removeEventListener('keydown', handleUserKeyPress);
        };
    });

    useEffect(() => {
        if (!isEmpty(fields.captcha.token) && fields.captcha.require) {
            setFields(state => ({
                ...state,
                ['sign_up_realtor']: {value: registerRealtor, error: '', loading: false},
            }));
        }
    }, [fields.captcha])

    const handleCityChange = (data) => {
        if (typeof data.items[0] !== "undefined") {
            const city_id = data.items[0];
            handleChange(null, 'city_id', city_id);

            getDistricts(city_id)
        }
    };

    const getDistricts = async (city_id) => {
        setDistrictLoading(true);

        await districtsSelection(city_id).then(result => {
            setDistrict(result);
            setDistrictLoading(false);
        });
    };

    const handleDistrictChange = async (data) => {
        let district_id = null;

        if (typeof data.items[0] !== "undefined") {
            district_id = data.items[0];
        }

        handleChange(null, 'district_id', district_id);
    };

    const handleChange = (e, field = '', value = '') => {

        if (field === '' && value === '') {
            field = e.target.name;
            value = e.target.value;
        }

        setRegisterRealtor(state => ({
            ...state,
            [field]: value,
        }));
    };

    const handleValidation = (data, rules) => {
        let errors = [];

        Object.keys(data).forEach((key) => {
            if (!isEmpty(rules[key]) && isEmpty(data[key]) && rules[key] === 'required') {
                errors.push(key)
            }
        })

        return errors;
    };

    const handleSingUp = () => {
        setRegisterRealtor(state => ({
            ...state,
            errors: errorsFields
        }));

        const rules = {
            name: "required",
            agency_name: "required",
            city_id: "required",
            district_id: "required",
        };

        const validator = handleValidation(registerRealtor, rules);

        if (validator.length > 0) {

            let errorsCopy = errorsFields;

            Object.keys(errorsCopy).forEach((key) => {
                errorsCopy[key]['show'] = false;
            });

            Object.keys(validator).forEach((key) => {
                const item = validator[key]
                errorsCopy[item]['show'] = true;
            });

            setRegisterRealtor(state => ({
                ...state,
                validator: errorsCopy
            }));
        } else {
            setFields(state => ({
                ...state,
                ['sign_up_realtor']: {value: registerRealtor, error: '', loading: true},
            }));

            const to_level = '';
            handleRegister(to_level, true);
        }
    };

    return (
        <Container show={level.sign_up_realtor}>
            <HandleLoginHeader title="تکمیل ثبت‌نام" close={() => setShow(false)} back={() => handleContinue('sing_up_type')} back_class=""/>

            <div className="mt-40">
                <div>
                    <Input type="text"
                           name="name"
                           id="name"
                           label="نام و نام خانوادگی"
                           className="mt-8"
                           value={registerRealtor.name}
                           onChange={(e) => handleChange(e)}
                           isInvalid={registerRealtor.errors.name.show}
                           invalidFeedback={registerRealtor.errors.name.text}
                    />
                </div>

                <div>
                    <Input type="text"
                           name="agency_name"
                           label="نام دفتر املاک"
                           className="mt-8 "
                           value={registerRealtor.agency_name}
                           onChange={handleChange}
                           isInvalid={registerRealtor.errors.agency_name.show}
                           invalidFeedback={registerRealtor.errors.agency_name.text}
                    />
                </div>

                <div className="row mt-24">
                    <div className="col-12">
                        <span className="mb-8 d-block">شهر</span>
                        <Selection
                            type="single"
                            name={'city_id'}
                            searchable
                            options={cities.options}
                            label="شهر"
                            loading={false}
                            onChange={(data) => handleCityChange(data)}
                        />

                        {
                            (registerRealtor.errors.city_id.show) ?
                                <small className="text-danger-text">
                                    {registerRealtor.errors.city_id.text}
                                </small>
                                : ''
                        }
                    </div>

                    <div className="col-12 mt-24">
                        <span className="mb-8 d-block">خیابان اصلی</span>
                        <Selection
                            type="single"
                            name="district_id"
                            searchable
                            options={districts.options}
                            label="خیابان اصلی"
                            loading={(districtLoading)}
                            onChange={(data) => handleDistrictChange(data)}
                        />

                        {
                            (registerRealtor.errors.district_id.show) ?
                                <small className="text-danger-text">
                                    {registerRealtor.errors.district_id.text}
                                </small>
                                : ''
                        }
                    </div>
                </div>


                {
                    (level.sign_up_realtor && !isEmpty(fields.captcha.token) && fields.captcha.require) ?
                        <Captcha
                            handleChange={handleCaptchaChange}
                            token={fields.captcha.token}
                            error={fields.captcha_code.error}
                            captchaValue={fields.captcha.value}
                            handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                            className="mt-24"
                        />
                        : ''
                }

                <ButtonBase disabled={fields.sign_up_realtor.loading} onClick={() => handleSingUp()} color="secondary" block className={"mt-24 "}>
                    {
                        (fields.sign_up_realtor.loading) ?
                            <CircleLoading width={24} height={24}/>
                            :
                            'ادامه'
                    }
                </ButtonBase>
            </div>
        </Container>
    )
}

export default SignUpRealtor;

// styles

// styles
const Container = styled.div`
  display: ${props => props.show ? 'block' : 'none'};

  ${SelectionContainer} {
    ${RadiusGenerate('8px')};
    border: solid 1px ${props => props.theme.gray200};
    height: 2.5rem;
    margin-left: 0;

    ${SelectionDropdownContainer} {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      padding: 24px 8px;

      ${SelectionDropdownHeader} {
        display: flex;
        height: 50px;
      }

      ${SelectionDropdownList} {
        height: calc(100% - 112px);
        max-height: calc(100% - 112px);
      }

      .scrollbar-container {
        overflow-y: auto;
      }
    }
  }
`;